import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { keys } from "lodash";

import { CustomSubscriptionService } from "Bands/services";
import {
  BAND_ACTIONS,
  ICustomSubscriptionParams,
  ICustomSubscriptionPatchParams,
  ICustomSubscriptionRequestParams,
} from "Bands/types";
import { IDataKeys } from "shared/types";
import { API_ENDPOINTS } from "shared/constants";

export const requestCustomSubscription = createAsyncThunk(
  BAND_ACTIONS.requestCustomSubscription,
  async (
    subscription: ICustomSubscriptionRequestParams,
    { rejectWithValue }
  ) => {
    try {
      const data = await CustomSubscriptionService.requestSubscription(
        subscription
      );
      const key = keys(data.customSubscriptionRequest)[0];
      const createdItem = data.customSubscriptionRequest?.[key];
      return { createdItem };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCustomSubscription = createAsyncThunk(
  BAND_ACTIONS.createCustomSubscription,
  async (subscription: ICustomSubscriptionParams, { rejectWithValue }) => {
    try {
      const data = await CustomSubscriptionService.createSubscription(
        subscription
      );
      const id = Object.values(data?.subscription)?.[0]?.attributes?.id;
      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editCustomSubscription = createAsyncThunk(
  BAND_ACTIONS.editCustomSubscription,
  async (
    {
      subscriptionId,
      subscriptionData,
    }: {
      subscriptionId: string;
      subscriptionData: ICustomSubscriptionPatchParams;
    },
    { rejectWithValue }
  ) => {
    try {
      const editedCompany = await CustomSubscriptionService.editSubscription(
        subscriptionId,
        subscriptionData
      );
      return editedCompany;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCustomSubscriptionRequest = createAsyncThunk(
  BAND_ACTIONS.deleteCustomSubscriptionRequest,
  async (requestId: string, { rejectWithValue }) => {
    try {
      await CustomSubscriptionService.deleteRequest(requestId);

      return {
        path: API_ENDPOINTS.CUSTOM_SUBSCRIPTION_REQUEST(requestId),
        dataKey: IDataKeys.customSubscriptionRequest,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const disptachGetCustomSubscriptionRequests = ({
  dispatch,
  company,
  band,
}: {
  dispatch: Dispatch<any>;
  company?: string;
  band?: string;
}) => {
  dispatch(
    getCustomSubscriptionRequests({
      company,
      band,
    })
  );
};

export const getCustomSubscriptionRequests = createAsyncThunk(
  BAND_ACTIONS.getCustomSubscriptionRequests,
  async (
    { company, band }: { company: string | undefined; band?: string },
    { rejectWithValue }
  ) => {
    try {
      const data = await CustomSubscriptionService.getSubscriptionRequests({
        company,
        band,
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.customSubscriptionRequest]: data.customSubscriptionRequest,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
